import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../component/shared/shared.service";
import { Diagnoses } from "../model/diagnoses";
import { DiagnoseService } from "../services/diagnose.service";
import {
  DialogAction,
  ActionMessage
} from "../../../shared/enum/dialog-action.enum";
import { TagMasterService } from "../services/tag-master.service";
@Component({
  selector: "app-diagnose",
  templateUrl: "./system-info.component.html",
  styleUrls: ["./system-info.component.css"]
})
export class SystemInfoComponent implements OnInit {
  listLoading = false;
  appInfo: any = {
    LastVersionAND: "",
    LastVersionIOS: "",
    IsForceAND: false,
    IsForceIOS: false
  };
  constructor(private _srvService: TagMasterService) {}

  getSystemInfo(): void {
    this.listLoading = true;
    this._srvService.getSystemInfo().subscribe(
      data => {
        this.listLoading = false;
        const dt = data["Item"];
        this.appInfo.LastVersionAND = dt.LastVersionAND;
        this.appInfo.LastVersionIOS = dt.LastVersionIOS;
        this.appInfo.IsForceIOS = dt.IsForceIOS == 1 ? true : false;
        this.appInfo.IsForceAND = dt.IsForceAND == 1 ? true : false;
      },
      error => {
        this.listLoading = false;
      }
    );
  }

  ngOnInit() {
    this.getSystemInfo();
  }

  saveAndroidInfo() {
    this.listLoading = true;
    this._srvService
      .saveSystemInfo({
        Type: 0,
        LastVersion: this.appInfo.LastVersionAND,
        IsForce: this.appInfo.IsForceAND ? 1 : 0
      })
      .subscribe(
        data => {
          this.listLoading = false;
          this.getSystemInfo();
        },
        error => {
          this.listLoading = false;
        }
      );
  }

  saveIOSInfo() {
    this.listLoading = true;
    this._srvService
      .saveSystemInfo({
        Type: 1,
        LastVersion: this.appInfo.LastVersionIOS,
        IsForce: this.appInfo.IsForceIOS ? 1 : 0
      })
      .subscribe(
        data => {
          this.listLoading = false;
          this.appInfo.LastVersionIOS = "";
          this.getSystemInfo();
        },
        error => {
          this.listLoading = false;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/section/master/system-info/system-info.component.ts